module.exports = __webpack_public_path__ + "static/media/banner-sample-01.1faba49e.jpg";